import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/inspect/workOrder'

/** 待检工单分页（简单检验） */
// export const waitInspectOrderPage = (params) => {
//   return axios.post(`${rootApi}/waitInspectOrderPage`, params, {dataType: 'json'})
// }

/** 已检工单分页（简单检验） */
// export const completeInspectOrderPage = (params) => {
//   return axios.post(`${rootApi}/completeInspectOrderPage`, params, {dataType: 'json'})
// }

/** 待检工单分页（方案检验） */
// export const waitInspectBySheetPage = (params) => {
//   return axios.post(`${rootApi}/waitInspectBySheetPage`, params, {dataType: 'json'})
// }

/** 已检工单分页（方案检验） */
// export const completeInspectBySheetPage = (params) => {
//   return axios.post(`${rootApi}/completeInspectBySheetPage`, params, {dataType: 'json'})
// }

// /** 获取工单检验信息（检验类型、检验方案） */
// export const getWorkOrderInspectParam = (inspectOrderId, inspectModality) => {
//   return axios.get(`${rootApi}/${inspectOrderId}/${inspectModality}/inspectParam`)
// }

/** 简易检验提交 */
// export const setInspectInfo = (params) => {
//   return axios.post(`${rootApi}/inspectInfo`, params)
// }

/** 获取检验记录列表 */
// export const getInspectRecordList = (inspectOrderId) => {
//   return axios.get(`${rootApi}/inspectRecordList/${inspectOrderId}`)
// }

/** 获取检验记录详情 */
// export const getInspectRecordDetails = (inspectRecordId) => {
//   return axios.get(`${rootApi}/inspectRecordDetails/${inspectRecordId}`)
// }

/** 获取所有检验记录详情 */
// export const getInspectAllRecordDetails = (inspectOrderId) => {
//   return axios.get(`${rootApi}/inspectAllRecordDetails/${inspectOrderId}`)
// }


/** 简易检验可选择项 */
export const getInspectItems = (processId) => {
  return axios.get(`${rootApi}/${processId}/inspectItems`)
}

/** 简易检验获取不良详情 */
export const getInspectDetails = (inspectOrderId, params) => {
  return axios.get(`${rootApi}/${inspectOrderId}/inspectDetails`, { params })
}

/** 提交生产检验（单独的检验工单） */
export const inspectBySheetSubmit = (params) => {
  return axios.post(`${rootApi}/production/submit`, params, {dataType: 'json'})
}

/** 提交首件检 */
export const firstSheetSubmit = (params) => {
  return axios.post(`${rootApi}/first/submit`, params, {dataType: 'json'})
}

// /** 提交巡检 */
// export const patrolSheetSubmit = (params) => {
//   return axios.post(`${rootApi}/patrol/submit`, params, {dataType: 'json'})
// }

// /** 提交完工检 */
// export const completeSheetSubmit = (params) => {
//   return axios.post(`${rootApi}/complete/submit`, params, {dataType: 'json'})
// }

/** 验证是否开启自检 */
export const selfInspectValid = (inspectOrderId) => {
  return axios.post(`${rootApi}/self/${inspectOrderId}/valid`)
}

/** 自检提交 */
export const selfSheetSubmit = (inspectOrderId, params) => {
  return axios.post(`${rootApi}/self/${inspectOrderId}/submit`, params, {dataType: 'json'})
}
/** 创建返修记录 */
export const addRepairRecordData = (params) => {
  return axios.post(`/api_v2/repairOrder/addRepairRecordData`, params, {dataType: 'json'})
}